import {
  START_GET_PHARMACIES_LIST,
  SUCCESS_GET_PHARMACIES_LIST,
  ERROR_GET_PHARMACIES_LIST,
  START_CREATE_PHARMACY,
  SUCCESS_CREATE_PHARMACY,
  ERROR_CREATE_PHARMACY,
  START_UPDATE_PHARMACY,
  START_DELETE_PHARMACY,
  SUCCESS_UPDATE_PHARMACY,
  ERROR_UPDATE_PHARMACY,
  SUCCESS_DELETE_PHARMACY,
  ERROR_DELETE_PHARMACY,
} from "Actions/PharmacyAction";
import { ADD_NEW_NOTIFICATION } from "Actions/ConfigAction";
import {
  createPharmacyAPI,
  deletePharmacyAPI,
  getPharmaciesListAPI,
  updatePharmacyAPI,
} from "Api/PharmacyApi";
import { call, put, takeEvery } from "redux-saga/effects";

function* getPharmacylistWorker({ payload }) {
  try {
    const res = yield call(getPharmaciesListAPI, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_GET_PHARMACIES_LIST,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_GET_PHARMACIES_LIST,
        payload: res,
      });
    }
  } catch (error) {}
}

function* createPharmacyWorker({ payload }) {
  try {
    const res = yield call(createPharmacyAPI, payload);
    if (res?.success) {
      yield put({
        type: SUCCESS_CREATE_PHARMACY,
        payload: res,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Pharmacy Added successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_CREATE_PHARMACY,
        payload: res,
      });
    }
  } catch (error) {}
}

function* updatePharmacyWorker({ id, payload }) {
  try {
    const res = yield call(updatePharmacyAPI, id, payload);
    if (res?.success) {
      yield put({
        type: SUCCESS_UPDATE_PHARMACY,
        payload: res,
        id: id,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Pharmacy Updated successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_UPDATE_PHARMACY,
        payload: res,
      });
    }
  } catch (error) {}
}

function* deletePharmacyWorker({ id }) {
  try {
    const res = yield call(deletePharmacyAPI, id);
    if (res.success) {
      yield put({
        type: SUCCESS_DELETE_PHARMACY,
        payload: res,
        id: id,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Pharmacy Deleted Successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_DELETE_PHARMACY,
        payload: res,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: res.errors.id[0],
          type: "error",
        },
      });
    }
  } catch (error) {}
}

export function* PharmacyWatcher() {
  yield takeEvery(START_GET_PHARMACIES_LIST, getPharmacylistWorker);
  yield takeEvery(START_CREATE_PHARMACY, createPharmacyWorker);
  yield takeEvery(START_UPDATE_PHARMACY, updatePharmacyWorker);
  yield takeEvery(START_DELETE_PHARMACY, deletePharmacyWorker);
}
